import { IApplicationState } from '../../types/redux';

export const selectIsUnfinishedAnketaModalOpen = (state: IApplicationState): boolean =>
  state.calculator.unfinishedAnketaModal.isOpen;
